import { create } from 'zustand'

export interface CreationState {
  step: number
  campaignId: string
  characterRole: 'pc' | 'npc'
  // Step 1: Identity
  name: string
  species_id: string
  sex: 'Male' | 'Female'
  culture_id: string
  social_class: string
  // Step 2: Birthday
  birth_year: number
  birth_month: number
  birth_day: number
  sunsign_id: string
  on_cusp: boolean
  // Step 3: Appearance
  height_inches: number
  frame: string
  weight_lbs: number
  comeliness: number
  complexion: string
  hair_color: string
  eye_color: string
  // Step 4: Attributes
  attr_str: number; attr_sta: number; attr_dex: number; attr_agl: number
  attr_eye: number; attr_hrg: number; attr_sml: number; attr_voi: number
  attr_int: number; attr_aur: number; attr_wil: number
  morality: number
  // Step 5: Occupation & Deity
  occupation_name: string
  deity: string
  piety: number
  // Step 6: Family
  sibling_rank: string
  family_size: number
  parent_status: string
  estrangement: string
  // Actions
  setField: <K extends keyof CreationState>(key: K, value: CreationState[K]) => void
  nextStep: () => void
  prevStep: () => void
  goToStep: (step: number) => void
  reset: () => void
}

const INITIAL: Omit<CreationState, 'setField' | 'nextStep' | 'prevStep' | 'goToStep' | 'reset'> = {
  step: 1,
  campaignId: '',
  characterRole: 'pc',
  name: '',
  species_id: 'Human',
  sex: 'Male',
  culture_id: 'Feudal',
  social_class: 'Unguilded',
  birth_year: 700,
  birth_month: 1,
  birth_day: 1,
  sunsign_id: 'Ulandus',
  on_cusp: false,
  height_inches: 68,
  frame: 'Medium',
  weight_lbs: 160,
  comeliness: 10,
  complexion: 'Fair',
  hair_color: 'Brown',
  eye_color: 'Brown',
  attr_str: 10, attr_sta: 10, attr_dex: 10, attr_agl: 10,
  attr_eye: 10, attr_hrg: 10, attr_sml: 10, attr_voi: 10,
  attr_int: 10, attr_aur: 10, attr_wil: 10,
  morality: 10,
  occupation_name: '',
  deity: '',
  piety: 0,
  sibling_rank: '1 of 1',
  family_size: 1,
  parent_status: 'Both alive',
  estrangement: 'Average',
}

export const useCreationStore = create<CreationState>((set) => ({
  ...INITIAL,
  setField: (key, value) => set({ [key]: value }),
  nextStep: () => set((s) => ({ step: s.step + 1 })),
  prevStep: () => set((s) => ({ step: Math.max(1, s.step - 1) })),
  goToStep: (step) => set({ step }),
  reset: () => set(INITIAL),
}))
